import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Meta Pixel Code
(function(f,b,e,v,n,t,s) {
  if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)
})(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');

// Remplacez 'VOTRE_PIXEL_ID' par votre vrai                
window.fbq('init', '25631160439871652');
window.fbq('track', 'PageView');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);